import { render, staticRenderFns } from "./floor-1-Item.vue?vue&type=template&id=8aae4e98&scoped=true&"
import script from "./floor-1-Item.vue?vue&type=script&lang=js&"
export * from "./floor-1-Item.vue?vue&type=script&lang=js&"
import style0 from "./floor-1-Item.vue?vue&type=style&index=0&id=8aae4e98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aae4e98",
  null
  
)

component.options.__file = "floor-1-Item.vue"
export default component.exports